import { render, staticRenderFns } from "./Activities.vue?vue&type=template&id=19bda9ac&scoped=true"
import script from "./Activities.vue?vue&type=script&lang=js"
export * from "./Activities.vue?vue&type=script&lang=js"
import style0 from "./Activities.vue?vue&type=style&index=0&id=19bda9ac&prod&scoped=true&lang=css"
import style1 from "./Activities.vue?vue&type=style&index=1&id=19bda9ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bda9ac",
  null
  
)

export default component.exports